import { Logout01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const LogOut = /* @__PURE__ */ createIcon(Logout01Icon, 'LogOut');
